import React, { useEffect, useRef } from "react";
import { StytchB2B, useStytchMemberSession } from "@stytch/react/b2b";
import { AuthFlowType, B2BProducts } from "@stytch/vanilla-js/b2b";
import { useNavigate, useLocation } from "react-router-dom";
import BasicLayout from "layouts/authentication/components/BasicLayout";
import bgImage from "assets/images/city_night_reduced.jpg";
import { AuthProvider } from "../../context/AuthContext";
import AuthHeader from "layouts/auth/AuthHeader";

const Auth: React.FC = () => {
    const config = {
        products: [B2BProducts.passwords, B2BProducts.emailOtp ],
        sessionOptions: { sessionDurationMinutes: 180 },
        authFlowType: AuthFlowType.Discovery,
    };

    const { session, fromCache } = useStytchMemberSession();
    const navigate = useNavigate();
    const location = useLocation();
    const hasNavigated = useRef(false);

    const from = (location.state as { from?: { pathname: string } } | null)?.from?.pathname || "/";

    useEffect(() => {
        if (!hasNavigated.current && !fromCache && session) {
            hasNavigated.current = true; // prevent future navs
            navigate(from, { replace: true });
        }
    }, [session, fromCache, navigate, from]);

    // Add back the session check
    if (!fromCache && session) {
        return null;
    }

    return (
        <AuthProvider>
            <div
                style={{
                    backgroundImage: `url(${bgImage})`,
                    backgroundSize: "cover",
                    backgroundPosition: "center",
                    backgroundRepeat: "no-repeat",
                    minHeight: "100vh",
                    width: "100%",
                }}
            >
                <AuthHeader brand="SoundMonitor.io" links={["Features", "Applications", "Pricing"]} context="external"/>

                <div
                    style={{
                        display: "flex",
                        justifyContent: "center",
                        alignItems: "center",
                        height: "100vh",
                    }}
                >
                    <div className="stytch-widget-container"
                        style={{    marginTop: "80px",
                    }}>
                        <StytchB2B config={config}/>
                    </div>
                </div>
                <style>
                    {`
                        .stytch-widget-container {
                            width: 400px !important;
                            min-height: 600px !important;
                            overflow: visible !important;
                            position: relative;
                        }
                    `}
                </style>
            </div>
        </AuthProvider>
);
};

export default Auth;
